<template>
  <div class="row pt-3" v-for="(propVal, property) in localValue" :key="property">
    <div class="col">
      <div class="form-floating">
        <form-input
          :name="property"
          :placeholder="trans(`models.${resourceType}.properties.${property}`)"
          :value="propVal ?? ''"
          @update:data="(updatedValue) => updateData(updatedValue, property)"
        />
        <label :for="property">
          {{ trans(`models.${resourceType}.properties.${property}`) }}
        </label>
      </div>
    </div>
  </div>
  <div class="d-flex row pt-2">
    <div class="col-5 pe-0">
      <div class="form-floating">
        <form-input :name="'newPropName'" :value="newPropName" @update:data="(data) => newPropName = data"/>
        <label for="newPropName">Name der neuen Eigenschaft</label>
      </div>
    </div>
    <div class="col-5 px-0">
      <div class="form-floating">
        <form-input :name="'newPropValue'" :value="newPropValue" @update:data="(data) => newPropValue = data"/>
        <label for="newPropValue">Inhalt</label>
      </div>
    </div>
    <div class="col-2 flex-0 px-0">
      <div class="form-floating">
        <button type="button" @click="addProperty()">+</button>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from '@kanrisha/components/Elements/Form/TextInput';
import { ref } from 'vue';

export default {
  components: {
    FormInput,
  },
  props: {
    value: { type: Object, default: () => {} },
    resourceType: { type: String, default: '' },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localValue = ref(props.value ?? {});
    const newPropName = ref('');
    const newPropValue = ref('');

    const updateData = (val, property) => {
      localValue.value[property] = val;
      emit('update:data', localValue.value);
    };

    const addProperty = () => {
      if (newPropName.value) {
        updateData(newPropValue.value, newPropName.value);
        newPropName.value = '';
        newPropValue.value = '';
      }
    };

    return {
      addProperty,
      localValue,
      newPropName,
      newPropValue,
      updateData,
    };
  },
};
</script>
